import { RouteRecordRaw } from 'vue-router';
import { Role } from '@/router/enum';

export const androidScreenRoute: RouteRecordRaw = {
  path: 'android-screen',
  name: 'android-screen',
  meta: {
    title: '安卓屏',
    key: 'android-screen',
    icon: 'fund-projection-screen-outlined',
    permission: [Role.ADMIN, Role.USER, Role.ANDROID_ADMIN],
  },
  children: [
    {
      path: 'android-device',
      name: 'android-device',
      component: () =>
        import('@/views/back-stage-management/Android/page/sn.vue'),
      meta: {
        title: '设备SN',
        key: 'android-device',
        icon: 'RobotOutlined',
        permission: [Role.ADMIN, Role.ANDROID_ADMIN],
      },
    },
    {
      path: 'android-gsf-id',
      name: 'android-gsf-id',
      component: () =>
        import(
          '@/views/back-stage-management/Android/page/gsf-id/gsf-id-page.vue'
        ),
      meta: {
        title: 'GSF-ID',
        key: 'android-gsf-id',
        icon: 'RobotOutlined',
        permission: [Role.ADMIN, Role.ANDROID_ADMIN],
      },
    },
  ],
};
